import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutSection from '../components/AboutSection';

function AboutPage() {
    return (
        <div className="about-page">
            <Helmet>
                <title>À Propos | Antiquaire Expert Paris - Stéphane Weinrich</title>
                <meta name="description" content="Découvrez l'histoire de Stéphane Weinrich, antiquaire expert depuis 1975. Trois générations d'expertise en antiquités, mobilier d'époque et objets d'art à Paris." />
            </Helmet>
            
            <main className="page-content">
                <AboutSection />
            </main>

            <style jsx>{`
                .about-page {
                    min-height: 100vh;
                    background: #f2f5f7;
                }

                .page-content {
                    position: relative;
                    z-index: 1;
                }

                @media (max-width: 768px) {
                    .about-page {
                        padding-top: 80px;
                    }
                }

                @media (max-width: 480px) {
                    .about-page {
                        padding-top: 100px;
                    }
                }
            `}</style>
        </div>
    );
}

export default AboutPage;
